import { Route, Routes } from 'react-router-dom';
import SystemError from '../../components/messages/SystemError';
import ErrorBoundary from '../../HOCs/ErrorBoundary';
import Companies from '../../pages/Admin/Companies/Companies';
import CompanyRegister from '../../pages/Admin/Companies/CompanyRegister';
import CompanyUpdate from '../../pages/Admin/Companies/CompanyUpdate';
import Roles from '../../pages/Admin/Roles/Roles';
import RolesRegister from '../../pages/Admin/Roles/RolesRegister';
import RolesUpdate from '../../pages/Admin/Roles/RolesUpdate';
import UserForm from '../../pages/Admin/Users/UserRegister';
import Users from '../../pages/Admin/Users/Users';
import UserUpdate from '../../pages/Admin/Users/UserUpdate';
import ApprovalSequences from '../../pages/Admin/ApprovalSequences/ApprovalSequences';
import ASCreate from '../../pages/Admin/ApprovalSequences/ASCreate';
import ASUpdate from '../../pages/Admin/ApprovalSequences/ASUpdate';

const AdminRoutes = () => {
  return (
    <div className="dashboardBG">
      <ErrorBoundary fallBack={<SystemError />}>
        <Routes>
          <Route path="/users" element={<Users />} />
          <Route path="/users/register" element={<UserForm />} />
          <Route path="/users/:userID" element={<UserUpdate />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/roles/register" element={<RolesRegister />} />
          <Route path="/roles/:roleID" element={<RolesUpdate />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/companies/register" element={<CompanyRegister />} />
          <Route path="/companies/:companyID" element={<CompanyUpdate />} />
          <Route path="/approval-sequences" element={<ApprovalSequences />} />
          <Route path="/approval-sequences/create" element={<ASCreate />} />
          <Route
            path="/approval-sequences/:approvalSequenceID"
            element={<ASUpdate />}
          />
        </Routes>
      </ErrorBoundary>
    </div>
  );
};

export default AdminRoutes;
